import React from 'react';
import { Mumbai, Delhi, Bengaluru, Hyderabad, Pune, Chennai } from '../../../icons';
import { useSelector, useDispatch } from 'react-redux';
import { setCity } from '../../../store/slices/eventSlice';
import { RootState } from '../../../store/store';

const locations = [
  { name: 'Mumbai', icon: Mumbai },
  { name: 'Delhi-NCR', icon: Delhi },
  { name: 'Bengaluru', icon: Bengaluru },
  { name: 'Hyderabad', icon: Hyderabad },
  { name: 'Pune', icon: Pune },
  { name: 'Chennai', icon: Chennai },
];

const LocationHeader: React.FC = () => {
  const dispatch = useDispatch();
  const { city } = useSelector((state: RootState) => state.event);

  const handleLocationClick = (locationName: string) => {
    if (city === locationName) {
      dispatch(setCity(undefined));
    } else {
      dispatch(setCity(locationName));
    }
  };

  return (
    <div className="md:flex justify-center items-center bg-black shadow p-4 rounded mb-4 text-white w-full">
      <div className="max-w-[700px] flex flex-grow">
        <div className="w-full grid grid-cols-3 gap-4 md:flex md:flex-row md:justify-between">
          {locations.map((location) => {
            const Icon = location.icon;
            return (
              <div
                key={location.name}
                className="flex flex-col justify-center items-center space-y-2 cursor-pointer"
                onClick={() => handleLocationClick(location.name)}
              >
                <Icon fillColor={city === location.name ? '#ECD996' : '#808080'} />
                <div className={`text-sm font-medium ${city === location.name ? 'text-[#ECD996]' : 'text-[#808080]'}`}>{location.name}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LocationHeader;
